import { ContactUs, CopyrightFooter, DataChart } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { PrivateFoundationsDataSources } from './DataSources';
import { Row, Col } from 'react-bootstrap';
const styles = require('./index.less')

class PrivateFoundations extends Container<{}, {}> {
  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section className="padding-top-lg">
        <div className="container" style={{ overflowX: 'hidden' }}>
          <div className="jumbotron animated fadeIn">
            <h1 className="hidden-xs">Investment Portfolios</h1>
            <h3 className="visible-xs">Investment Portfolios</h3>
            <p>Most definitions of Private Foundations describe their place in the overall nonprofit sector and include some legal distinctions differentiating them from other charities. These definitions are true and important, yet they fail to capture a critical point of view, most private foundations can be described as investment portfolios designed to generate returns. The chart below “Total Assets by Asset Class” shows that over 90% of private foundation assets are in investments.  Seen from an investment perspective, the FoundationMark universe contains over 40,000 portfolios.</p>
            <Row style={{ listStylePosition: 'inside' }}>
              <Col sm={12} md={4} style={{ padding: '40px' }}>
                <ul ><span style={{ fontSize: '1.5vw', fontWeight: 'bold', textDecoration: 'underline' }}>Asset Classes</span>
                  <li>Cash</li>
                  <li>Bonds
                    <ul>
                      <li>Government</li>
                      <li>Corporate</li>
                    </ul>
                  </li>
                  <li>Stock</li>
                  <li>Alternative Assets<ul><li>Hedge Funds</li><li>Private Equity</li></ul></li>
                </ul>
              </Col>
              <Col sm={12} md={8} style={{ textAlign: 'center', padding: '10px' }}>
                <DataChart datasource={PrivateFoundationsDataSources}
                  config={{
                    chart: {
                      type: 'pie',
                      height: '300px'
                    },
                    credits: {
                      enabled: false
                    },
                  }}
                  series={[
                    {
                      name: 'Foundation Portfolios',
                      color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 }, stops: [[0, '#041D37'], [0.5, '#ffffff'],
                        [1, '#3366AA']]
                      },
                      data: [{
                        yExpression: '$[i].y',
                        nameExpression: '$[i].name',
                        colorExpression: '$[i].color',
                        loop: true
                      },]
                    }
                  ]
                  }>
                </DataChart>
              </Col>
            </Row>
            <p>FoundationMark believes it is important to track the investment performance of foundations because better performance leads to increased resources for charitable purposes. Benchmarking performance can enable trustees and officers to make better informed investment decisions.</p>
          </div>
        </div>

        <ContactUs />
        <CopyrightFooter />
      </section >
    )
  }
}

export {
  PrivateFoundations
}



// WEBPACK FOOTER //
// ./src/app/containers/PrivateFoundations/index.tsx